module.exports = __webpack_public_path__ + "static/img/品牌logo3@3x.ded3249.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/品牌logo3@3x.png
// module id = 39N4
// module chunks = 192